module.exports = __webpack_public_path__ + "img/165.fac9ee05.jpg";